/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'
import * as AdminDefs from '../../../com/atproto/admin/defs.defs.js'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs.js'

const $nsid = 'tools.ozone.moderation.emitEvent'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  event: /*#__PURE__*/ l.typedUnion(
    [
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventTakedown>(
        (() => ModerationDefs.modEventTakedown) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventAcknowledge>(
        (() => ModerationDefs.modEventAcknowledge) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventEscalate>(
        (() => ModerationDefs.modEventEscalate) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventComment>(
        (() => ModerationDefs.modEventComment) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventLabel>(
        (() => ModerationDefs.modEventLabel) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventReport>(
        (() => ModerationDefs.modEventReport) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventMute>(
        (() => ModerationDefs.modEventMute) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventUnmute>(
        (() => ModerationDefs.modEventUnmute) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventMuteReporter>(
        (() => ModerationDefs.modEventMuteReporter) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventUnmuteReporter>(
        (() => ModerationDefs.modEventUnmuteReporter) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventReverseTakedown>(
        (() => ModerationDefs.modEventReverseTakedown) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventResolveAppeal>(
        (() => ModerationDefs.modEventResolveAppeal) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventEmail>(
        (() => ModerationDefs.modEventEmail) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventDivert>(
        (() => ModerationDefs.modEventDivert) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventTag>(
        (() => ModerationDefs.modEventTag) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.AccountEvent>(
        (() => ModerationDefs.accountEvent) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.IdentityEvent>(
        (() => ModerationDefs.identityEvent) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.RecordEvent>(
        (() => ModerationDefs.recordEvent) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ModEventPriorityScore>(
        (() => ModerationDefs.modEventPriorityScore) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.AgeAssuranceEvent>(
        (() => ModerationDefs.ageAssuranceEvent) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.AgeAssuranceOverrideEvent>(
        (() => ModerationDefs.ageAssuranceOverrideEvent) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.AgeAssurancePurgeEvent>(
        (() => ModerationDefs.ageAssurancePurgeEvent) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.RevokeAccountCredentialsEvent>(
        (() => ModerationDefs.revokeAccountCredentialsEvent) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.ScheduleTakedownEvent>(
        (() => ModerationDefs.scheduleTakedownEvent) as any,
      ),
      /*#__PURE__*/ l.typedRef<ModerationDefs.CancelScheduledTakedownEvent>(
        (() => ModerationDefs.cancelScheduledTakedownEvent) as any,
      ),
    ],
    false,
  ),
  subject: /*#__PURE__*/ l.typedUnion(
    [
      /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
        (() => AdminDefs.repoRef) as any,
      ),
      /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
        (() => RepoStrongRef.main) as any,
      ),
    ],
    false,
  ),
  subjectBlobCids: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'cid' })),
  ),
  createdBy: /*#__PURE__*/ l.string({ format: 'did' }),
  modTool: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<ModerationDefs.ModTool>(
      (() => ModerationDefs.modTool) as any,
    ),
  ),
  externalId: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  reportAction: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<ReportAction>((() => reportAction) as any),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<ModerationDefs.ModEventView>(
    (() => ModerationDefs.modEventView) as any,
  ),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Take a moderation action on an actor. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'SubjectHasAction',
  'DuplicateExternalId',
])

export { main }

export const $lxm = $nsid

/** Target specific reports when emitting a moderation event */
type ReportAction = {
  $type?: 'tools.ozone.moderation.emitEvent#reportAction'

  /**
   * Target specific report IDs
   */
  ids?: number[]

  /**
   * Target reports matching these report types on the subject (fully qualified NSIDs)
   */
  types?: string[]

  /**
   * Target ALL reports on the subject
   */
  all?: boolean

  /**
   * Note to send to reporter(s) when actioning their report
   */
  note?: string
}

export type { ReportAction }

/** Target specific reports when emitting a moderation event */
const reportAction = /*#__PURE__*/ l.typedObject<ReportAction>(
  $nsid,
  'reportAction',
  /*#__PURE__*/ l.object({
    ids: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.integer()),
    ),
    types: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    ),
    all: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    note: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { reportAction }
